const FABRICS = [
  { name: "Silk", swatch: "https://images.pexels.com/photos/14935628/pexels-photo-14935628.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300", tone: "fluid, glossy" },
  { name: "Velvet", swatch: "https://images.unsplash.com/photo-1676696706907-0e04665b80bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxzaWxrJTIwdmVsdmV0JTIwZmFicmljJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODc1NDM3NjN8MA&ixlib=rb-4.1.0&q=85", tone: "deep pile, plush" },
  { name: "Denim", swatch: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=300&q=80", tone: "raw indigo, structured" },
  { name: "Leather", swatch: "https://images.unsplash.com/photo-1519744792095-2f2205e87b6f?w=300&q=80", tone: "supple, natural grain" },
  { name: "Linen", swatch: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=300&q=80", tone: "textured, airy" },
  { name: "Wool", swatch: "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=300&q=80", tone: "warm, brushed" },
  { name: "Chiffon", swatch: "https://images.unsplash.com/photo-1628973434123-3e956f203dd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxzaWxrJTIwdmVsdmV0JTIwZmFicmljJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODc1NDM3NjN8MA&ixlib=rb-4.1.0&q=85", tone: "sheer, floating" },
  { name: "Tweed", swatch: "https://images.unsplash.com/photo-1521805103424-d8f8430e8933?w=300&q=80", tone: "flecked, tailored" },
  { name: "Latex", swatch: "https://images.unsplash.com/photo-1583744946564-b52ac1c389c8?w=300&q=80", tone: "high-shine, second-skin" },
  { name: "Cashmere", swatch: "https://images.unsplash.com/photo-1544441893-675973e31985?w=300&q=80", tone: "cloud-soft, matte" },
];

export default function FabricPicker({ value, onChange }) {
  return (
    <div className="grid grid-cols-5 gap-1.5" data-testid="fabric-picker">
      {FABRICS.map((f) => (
        <button
          key={f.name}
          type="button"
          onClick={() => onChange(value === f.name ? null : f.name)}
          className={`group relative aspect-square overflow-hidden border-2 transition-transform hover:scale-105 ${
            value === f.name ? "border-lime-400 scale-105" : "border-transparent"
          }`}
          data-testid={`fabric-swatch-${f.name.toLowerCase()}`}
          title={`${f.name} — ${f.tone}`}
        >
          <img src={f.swatch} alt={f.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          <div className="absolute bottom-1 left-1 right-1 text-[10px] uppercase tracking-widest text-white font-semibold text-left">{f.name}</div>
          {value === f.name && (
            <div className="absolute top-1 right-1 w-2 h-2 rounded-full bg-lime-400" />
          )}
        </button>
      ))}
    </div>
  );
}
